export default {
    data () {
        return {
            table: null,
            options: {
                debounce: 800,
                filterByColumn: true,
                filterable: [],
                sortIcon: {
                    base: 'ti',
                    up: 'ti-angle-up',
                    down: 'ti-angle-down'
                },
                templates: {
                    // actions: Actions
                },
                perPageValues: [],
                texts: {
                    count: this.uLang('app.table_record'),
                    filter: this.uLang('app.filter_results'),
                    filterPlaceholder: this.uLang('app.search_query'),
                    limit: this.uLang('app.results'),
                    noResults: this.uLang('app.no_matching_records'),
                    page: this.uLang('app.page'),
                    filterBy: this.uLang('app.filter_by')
                },
                // see the options API
                skin: "table-hover table-striped table-bordered",
                perPage: 15,
                // footerHeadings: true,
                highlightMatches: true,
                pagination: {
                    chunk: 5,
                    //set dropdown to true to get dropdown instead of pagenation
                    dropdown: false
                },
                responseAdapter: (response) => {

                    this.displayCorrectEmptyText(response);

                    return { data: response.data, count: response.total }
                }
            }
        }
    },

    created: function () {
        this.options.templates = this.templates;
        this.options.filterable = this.filterable;
    },

    mounted: function () {
        vue.$on('reloadTable', () => {
            if(this.$refs.table) {
                this.$refs.table.refresh()
            }
        })
    },

    methods: {
        /**
         * Display the correct text for an empty table when it is initialized as empty
         *
         * @param response
         */
        displayCorrectEmptyText (response) {

            let noFilters = Object.keys(response.filters).filter(key => response.filters[key]).length === 0;

            this.options.texts.noResults = (response.initialized_empty === true && noFilters) ?
                this.uLang('app.filter_for_records') :
                this.uLang('app.no_matching_records');
        },
    }
}
